import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import React, { FC, ReactElement, useState } from 'react'
import styled from 'styled-components'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import { UkraineMap } from 'components/UkraineMap'
import { Key } from 'components/Chart_Key'
import ContentGrid from 'components/ContentGrid'
import Column from 'components/Column'
import { useEffectOnce, useWindowSize } from 'usehooks-ts'
import { Scroller } from 'components/Scroller'
import { MicroFrontendProps } from '../../Types/MicroFrontendProps'
import { ReactVideoAndTracking } from 'components/ReactVideoAndTracking'

/*



*/
const ARTICLE_ID = '332408679013'
const FirmsData = require('../GeoJSON/nasa_firms_all.json')

const Controlled = {
  august: '2022-08-28-controlled.json',
  september: '2022-09-06-controlled.json',
}
const Advances = {
  august: '2022-08-28-advances.json',
  september: '2022-09-06-advances.json',
}
const Counter = {
  august: '2022-08-28-ua.json',
  september: '2022-09-06-ua.json',
}

/*



*/

const isMobile = window.innerWidth < 712
const MarkedPoints: { [key: string]: MapLabelType[] } = {
  _2: [
    // {
    //   label: 'Archanhelske',
    //   pos: [33.39518524888561, 47.42308580776444],
    //   offset: 'right',
    //   type: 'event',
    // },
    // {
    //   label: 'Ljubomiriwka',
    //   pos: [32.87520208131087, 47.18775108728645],
    //   offset: 'right',
    //   type: 'event',
    // },
    {
      label: 'Cherson',
      pos: [32.25, 46.67],
      offset: 'right',
      type: 'city',
    },
    {
      label: 'Melitopol',
      pos: [35.34368446491722, 46.854755457502776],
      offset: 'right',
      type: 'city',
    },
  ],
  _3: [
    {
      label: 'Antoniwka-Brücke',
      pos: [32.76, 46.64],
      offset: 'bottom',
      type: 'event',
    },
  ],
  _4: [
    {
      label: 'Nowa Kachowka',
      pos: [33.36883209595227, 46.62],
      offset: 'top',
      type: 'event',
    },
  ],
  _41: [
    {
      label: 'Tawrijsk',
      pos: [33.4, 46.71],
      offset: 'bottom',
      type: 'event',
    },
  ],
  _5: [
    {
      label: 'Mirnoe',
      pos: [32.32128373672366, 46.8052257400265],
      offset: 'top',
      type: 'event',
    },
  ],
  _51: [
    {
      label: 'Petrovka',
      pos: [33.785, 47.435],
      offset: 'top',

      type: 'event',
    },
  ],
  _6: [
    {
      label: 'Oleschki',
      pos: [32.75, 46.55],
      offset: 'top',
      type: 'event',
    },
  ],
  _7: [
    {
      label: 'Wissokopillja',
      pos: [33.52199933656515, 47.42],
      offset: 'top',
      type: 'event',
    },
  ],
  _71: [
    {
      label: 'Antoniwka-Brücke',
      pos: [32.76, 46.64],
      offset: 'right',
      type: 'event',
    },
  ],
  _8: [
    {
      label: 'Yevpatoria',
      pos: [33.3609299913627, 45.20341166334805],
      offset: 'top',
      type: 'event',
    },
  ],
}

const constAnnotations: MapLabelType[] = [
  // {
  //   label: 'Ukraine',
  //   pos: [32.5, 47.3],
  //   offset: 'left',
  //   type: 'country',
  // },
  {
    label: 'Krim',
    pos: [34.2, 45.5],
    offset: 'left',
    type: 'region',
  },
  {
    label: isMobile ? '' : 'Schwarzes Meer',
    pos: [32.5, 45.72885885748845],
    offset: 'left',
    type: 'region',
  },
  {
    label: isMobile ? '' : 'Dnjepr',
    pos: [35.1, 47.480460128287326],
    offset: 'left',
    type: 'region',
  },
]
const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties = {
    time: 'june',
    title: 'Title from MF-Properties',
    sub: 'Mai',
  },
}): ReactElement => {
  const { width } = useWindowSize()
  const [height, setHeight] = useState(0)
  useEffectOnce(() => {
    setHeight(window.innerHeight)
  })

  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]

  const TimeStringsKey = {
    august: 'am 28. August',
    september: 'am 6. September',
  }
  return (
    <AppContainer className={globalClasses.join(' ')}>
      {
        <ContentGrid>
          <Column wide>
            <Scroller
              defaultDistance={height * 1.2}
              front={[
                <FrontElement id='august_2_2022-09-08'>
                  <p>
                    Wie erfolgreich die Offensive verläuft, ist zum jetzigen
                    Zeitpunkt schwer zu sagen. Offizielle Informationen gibt es
                    kaum. Die ukrainische Seite meldete bereits in einem frühen
                    Stadium vereinzelte Rückeroberungen von Ortschaften. So
                    sollen russische Truppen bereits aus Ljubomiriwka und
                    Archanhelske und einer Reihe kleinerer Siedlungen verdrängt
                    worden sein. Auch russische Telegram-Kanäle haben diese
                    Erfolge bestätigt. Der Kreml liess hingegen gleich zu Beginn
                    der ukrainischen Offensive verlauten, diese sei gescheitert.
                  </p>
                  <p>
                    Mithilfe von Daten der Nasa lässt sich der Vorstoss der
                    Ukrainer zumindest in Teilen nachvollziehen. Die
                    US-Raumfahrtbehörde verfügt über Satelliten, die Brände und
                    thermische Anomalien auf der Erde erfassen – also
                    beispielsweise Waldbrände. Die Daten aus der Ukraine sind
                    mit einer Verzögerung von einigen Stunden verfügbar.
                  </p>
                </FrontElement>,
                <FrontElement id='august_2_2022-09-08'>
                  <p>
                    Im Kriegsgebiet entlang der Front in der Region Cherson ist
                    davon auszugehen, dass die von der Nasa erfassten Brände und
                    thermische Anomalien auf Kampfhandlungen hindeuten – also
                    beispielsweise Explosionen, Artilleriefeuer oder brennende
                    Felder nach einem Beschuss. Laut Niklas Masuhr, Analyst für
                    militärische Strategien am Zentrum für Sicherheitspolitik
                    der ETH Zürich, eignen sich die Nasa-Daten, um «grob den
                    Verlauf des Kriegsgeschehens nachzuzeichnen».
                  </p>
                  <p>
                    Seit Beginn der ukrainischen Rückeroberungen in der Region
                    Cherson häufen sich in den sozialen Medien Berichte über die
                    militärischen Erfolge der Ukrainer. Mithilfe der Nasa-Daten
                    lassen sich diese Postings teilweise nachvollziehen.
                  </p>
                  <p>
                    Grob gilt laut Analyst Masuhr Folgendes: Brandherde im
                    Rückraum der russischen Front stammen mit grosser
                    Wahrscheinlichkeit von Angriffen der ukrainischen Truppen.
                    Liegen die Herde auf russisch kontrolliertem Gebiet in der
                    Nähe der Front, dürfte es sich um Angriffe auf russische
                    Artilleriestellungen handeln. Hitzeanomalien tief im
                    Rückraum des russisch besetzten Gebiets zeigen aller
                    Wahrscheinlichkeit nach Angriffe der Ukrainer auf die
                    russische Logistik – also beispielsweise Munitionsdepots,
                    Konvois und Soldatenbaracken. Brandherde entlang der
                    Frontlinie können von beiden Kriegsparteien stammen.
                  </p>
                  <p>
                    Die folgenden Ereignisse seit offiziellem Beginn der
                    ukrainischen Rückeroberung lassen sich verifizieren
                    (berücksichtigt sind die Nasa-Daten bis und mit dem 8.
                    September):
                  </p>
                </FrontElement>,
                <FrontElement id='august_3_2022-08-29'>
                  <TimeTitle>Die Antoniwka-Brücke ist unter Feuer</TimeTitle>
                  <p>
                    Schon seit Wochen nehmen die ukrainischen Truppen die{' '}
                    <b>Antoniwka-Brücke</b> unter Beschuss. Sie gilt als
                    wichtige Route über den Fluss Dnjepr. Kann sie nicht mehr
                    passiert werden, verlieren die russischen Truppen eine
                    zentrale Versorgungsachse und vor allem auch eine
                    Rückzugsroute. Zumindest zeitweise war die Brücke
                    geschlossen. Ob sie derzeit genutzt werden kann, ist unklar.
                  </p>
                  <p>
                    Zum offiziellen Beginn der Gegenoffensive Ende August haben
                    die ukrainischen Truppen die Antoniwka-Brücke beschossen.
                    Dieses Video zeigt einen Volltreffer:
                  </p>
                  <Video
                    filename='antoniwkabruecke'
                    source='https://twitter.com/bayraktar_1love/status/1566479949082632192'
                  />
                  <p>
                    Der Beschuss der ukrainischen Truppen bildet sich auch in
                    den Daten der Nasa ab. Immer wieder gibt es unmittelbar bei
                    der Brücke Brände und Hitzeanomalien.
                  </p>
                  <p>
                    Dieses Video zeigt den Beschuss und die mächtigen
                    Rauchwolken aus einer grösseren Distanz. Das Material stammt
                    von Ende August:
                  </p>
                  <Video
                    filename='antoniwkabruecke2'
                    source='https://twitter.com/bayraktar_1love/status/1563117580356702208'
                  />
                  <p>
                    Wie durchlöchert die Brücke aussieht, zeigt dieses Bild. Es
                    wurde am 21. August aufgenommen – also vor dem offiziellen
                    Start der ukrainischen Gegenoffensive.
                  </p>
                  <Bild
                    filename='bruecke2.jpeg'
                    source='https://mil.in.ua/en/news/a-satellite-photo-of-the-antonivskyi-bridge-in-occupied-kherson-appeared-after-the-strikes-of-the-armed-forces-of-ukraine/'
                    sourceLabel='mil.in.ua'
                  />
                </FrontElement>,
                <FrontElement id='august_4_2022-08-30'>
                  <TimeTitle>
                    Die «systematische Zerschlagung von Putins Armee»
                  </TimeTitle>
                  <p>
                    Dass die ukrainischen Angriffe erfolgreich sind, belegen
                    auch die Kampfhandlungen in der Stadt <b>Nowa Kachowka</b>.
                    Hier gelingt es den Ukrainern am 30. August, russische
                    Transportfahrzeuge zu zerstören. Auch diese Beschüsse lassen
                    sich anhand der Nasa-Daten verifizieren. Angeblich sollen
                    dazu die von den USA gelieferten Mehrfachraketenwerfer
                    Himars genutzt worden sein.
                  </p>
                  <Bild
                    filename='nova.jpeg'
                    source='https://twitter.com/UAWeapons/status/1564716291663052800'
                  />
                </FrontElement>,
                <FrontElement id='august_41_2022-08-30'>
                  <p>
                    Ein häufiges Ziel der ukrainischen Truppen sind nicht nur
                    fragile Transport- und Rückzugsrouten wie Brücken, sondern
                    auch Munitionsdepots. In der russisch besetzten{' '}
                    <b>Stadt Tawrijsk</b> zerstört das ukrainische Militär ein
                    solches Depot. Diese sind häufig schlecht geschützt – und
                    daher ein vergleichsweise einfaches Ziel für die Ukrainer.
                  </p>
                  <Video
                    filename='tavriisk'
                    source='https://twitter.com/Archer83Able/status/1564645506793570305'
                  />
                </FrontElement>,
                <FrontElement id='august_5_2022-08-30'>
                  <p>
                    Der ukrainische Präsidentenberater Olexi Arestowitsch sagt
                    in einem Artikel des «Wall Street Journal», dass das Ziel
                    der ukrainischen Streitkräfte im Süden die «systematische
                    Zerschlagung von Putins Armee» sei und dass die ukrainischen
                    Truppen langsam und systematisch Russlands operatives
                    logistisches Versorgungssystem mit Artillerie- und
                    Präzisionswaffenangriffen aufdecken und zerstören würden.
                    Schnelle Rückeroberungen von verlorenem Territorium seien
                    hingegen nicht zu erwarten.
                  </p>
                  <p>
                    Kommt hinzu, dass die Gegenwehr der Russen trotz
                    vereinzelten Verlusten heftig ist. Noch immer ist ihr
                    Artilleriebeschuss entlang der Frontlinie in der Region
                    Cherson massiv. Zudem haben die Russen Einheiten, die sich
                    an der Ostfront bewährt haben, kürzlich an die Südfront bei
                    Cherson verlegt.{' '}
                  </p>
                  <p>
                    Tatsächlich finden sich auch einige erfolgreiche Beschüsse
                    von russischer Seite, die sich mit den Nasa-Daten
                    nachvollziehen lassen. In der Nähe von <b>Mirnoe</b>{' '}
                    zerstört die russische Artillerie vermutlich ebenfalls am
                    30. August einen ukrainischen Panzer - wie dieses Video
                    zeigt.
                  </p>
                  <Video
                    filename='mirnoe'
                    source='https://twitter.com/UAWeapons/status/1564718743288250368'
                  />
                </FrontElement>,
                <FrontElement id='august_51_2022-08-30'>
                  <p>
                    In der Nähe von <b>Petrowka</b> beschiessen die Russen zudem
                    einen ukrainischen Konvoi. Das Video zeigt die verlassenen
                    Panzer und Fahrzeuge der Ukrainer.
                  </p>
                  <Video
                    filename='petrovka'
                    source='https://twitter.com/UAWeapons/status/1564713937073049602'
                  />
                </FrontElement>,
                <FrontElement id='september_6_2022-09-03'>
                  <TimeTitle>
                    Die Ukraine nimmt den Luftkampf wieder auf
                  </TimeTitle>
                  <p>
                    Ein Indiz für den Erfolg der ukrainischen Angriffe zeigt
                    sich im Luftkampf. So scheint das ukrainische Militär diesen
                    wieder verstärkt zu führen.
                  </p>
                  <p>
                    Dieses Bild zeigt ein zerstörtes russisches
                    Kurzstrecken-Flugabwehrraketen-System Pantsir bei{' '}
                    <b>Oleschki</b>.
                  </p>
                  <Bild
                    filename='oleshky.jpg'
                    source='https://twitter.com/Archer83Able/status/1566004114374463489'
                  />
                  <p>
                    Zudem finden sich in den sozialen Medien vermehrt Videos,
                    die angeblich erfolgreiche Angriffe mit Bayraktar-Drohnen
                    der Ukrainer dokumentieren.
                  </p>
                  <p>
                    Dieses Video soll einen Schlag einer Bayraktar-Drohne gegen
                    russische Panzer zeigen, datiert ist die Aufnahme nicht:
                  </p>
                  <Video
                    filename='oleshky'
                    source='https://twitter.com/bayraktar_1love/status/1566681568864882699
                    '
                  />
                </FrontElement>,
                <FrontElement id='september_6_2022-09-03'>
                  <p>
                    Für ETH-Militäranalyst Masuhr ist der Erfolg der Ukraine in
                    der Luft «gemessen an den Annahmen zu Beginn des Kriegs eine
                    der grossen Überraschungen». Zum einen hätten es die
                    Ukrainer kürzlich geschafft, amerikanische
                    Anti-Radar-Raketen an eigenen Kampfflugzeugen anzubringen.
                    So könnten sie auch Radarsysteme der Russen weit hinter der
                    Frontlinie angreifen. Zudem habe die Ukraine mittlerweile
                    schlicht noch mehr Luftabwehrsysteme aus dem Westen
                    erhalten. Das gebe dem Militär mehr Handlungsspielraum – und
                    erlaube temporär auch wieder Schläge mit Drohnen.
                  </p>
                </FrontElement>,
                <FrontElement id='september_7_2022-09-04'>
                  <TimeTitle>Die Flagge von Wissokopillja</TimeTitle>
                  <p>
                    Am 4. September erobern ukrainische Truppen das{' '}
                    <b>Dorf Wissokopillja</b> von den Russen zurück. Drei
                    ukrainische Soldaten hissen nach gewonnener Schlacht im
                    Morgengrauen die ukrainische Flagge auf einem Telefonmast.
                    Die Rückeroberung des Dorfes bestätigt sowohl die russische
                    als auch die ukrainische Seite. Die Kampfhandlungen zeigen
                    sich auch in den Nasa-Daten.
                  </p>
                  <Bild
                    filename='flagge.jpeg'
                    source='https://twitter.com/Militarylandnet/status/1566386958586224640'
                  />
                </FrontElement>,
                <FrontElement id='september_71_2022-09-05' distance={400}>
                  <TimeTitle>
                    Der Beschuss der Antoniwka-Brücke dauert an
                  </TimeTitle>
                  <p>
                    Gleichzeitig setzen die Ukrainer ihre Taktik fort und
                    greifen immer wieder Ziele weit hinter der russischen Front
                    an. So nimmt das Militär am 5. September einmal mehr die{' '}
                    <b>Antoniwka-Brücke</b> unter Beschuss. Hier ist das
                    südliche Ende der Brücke zu sehen:
                  </p>
                  <Bild
                    filename='bruecke.jpeg'
                    source='https://twitter.com/Osinttechnical/status/1566670500054671364'
                  />
                </FrontElement>,
              ]}
              back={(index, id) => {
                if (!id) id = ''
                let [month, annotations, date] = id.split('_')
                if (!month) month = 'august'
                if (!annotations) annotations = '2'
                return (
                  <>
                    <Column style={{ height: height + 'px' }}>
                      <MapWrapper className='MapWrapper'>
                        <UkraineMap
                          height={height}
                          data={FirmsData}
                          date={date}
                          russianControl={require('../GeoJSON/' +
                            Controlled.september)}
                          russianAdvance={require('../GeoJSON/' +
                            Advances.september)}
                          uaCounter={require('../GeoJSON/' + Counter.september)}
                          mapLabels={
                            MarkedPoints['_' + annotations]
                              ? constAnnotations.concat(
                                  MarkedPoints['_' + annotations]
                                )
                              : constAnnotations
                          }
                          colorMode={colorMode}
                          index={index}
                        />

                        <KeyWrapper>
                          <Key
                            entries={[
                              {
                                type: 'rect',
                                label: (
                                  <>
                                    Von Russland kontrollierte Gebiete{' '}
                                    <span>{TimeStringsKey.september}</span>
                                  </>
                                ),
                                color:
                                  colorMode === 'light'
                                    ? 'var(--red-bright-2)'
                                    : 'var(--red-main)',
                              },
                              {
                                type: 'rect-pattern',
                                label: (
                                  <>
                                    Russische Vorstösse{' '}
                                    <span>{TimeStringsKey.september}</span>
                                  </>
                                ),
                                color:
                                  colorMode === 'light'
                                    ? 'var(--red-main)'
                                    : 'var(--red-main)',
                              },
                              {
                                type: 'rect-pattern',
                                label: (
                                  <>
                                    Vorstösse der Ukraine{' '}
                                    <span>{TimeStringsKey.september}</span>
                                  </>
                                ),
                                color: 'var(--blue-main)',
                              },
                            ]}
                          />

                          <Source>
                            Quelle:{' '}
                            <a
                              href='https://firms.modaps.eosdis.nasa.gov//'
                              target={width < 712 ? '_self' : '_blank'}
                            >
                              FIRMS
                            </a>
                            ,{' '}
                            <a
                              href='https://www.understandingwar.org/'
                              target={width < 712 ? '_self' : '_blank'}
                            >
                              ISW
                            </a>
                          </Source>
                        </KeyWrapper>
                      </MapWrapper>
                    </Column>
                  </>
                )
              }}
            />
          </Column>
        </ContentGrid>
      }
    </AppContainer>
  )
}

const Video = ({ filename, source }: { filename: string; source: string }) => {
  return (
    <>
      <ReactVideoAndTracking
        articleId={ARTICLE_ID}
        videoUrls={[
          'https://interaktiv.tagesanzeiger.ch/2022/gegenoffensive/' +
            filename +
            '.mp4',
          'https://interaktiv.tagesanzeiger.ch/2022/gegenoffensive/' +
            filename +
            '.webm',
        ]}
        debug
      />
      <VideoSource>
        Quelle: <a href={source}>Twitter</a>
      </VideoSource>
    </>
  )
}
const Bild = ({
  filename,
  source,
  sourceLabel,
}: {
  filename: string
  source: string
  sourceLabel?: string
}) => {
  return (
    <p>
      <img src={require('../../assets/bilder/' + filename)} />
      <VideoSource>
        Quelle: <a href={source}>{sourceLabel ? sourceLabel : 'Twitter'}</a>
      </VideoSource>
    </p>
  )
}

const FrontElement = styled.div<{ distance?: number }>`
  text-align: left;
  background-color: var(--site-background);
  color: var(--text-color);
  font-size: 18px;
  padding: 30px;
  border-radius: 2px;
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-family: var(--font-serif);
  line-height: 3rem;
  max-width: 606px;
  -webkit-box-shadow: 0px 0px 9px -1px rgba(0, 0, 0, 0.3),
    0px 0px 9px -1px rgba(255, 255, 255, 0.3);
  box-shadow: 0px 0px 9px -1px rgba(0, 0, 0, 0.3),
    0px 0px 9px -1px rgba(255, 255, 255, 0.3);
  img {
    max-width: 100%;
  }
  &.high {
    margin-top: 300px;
  }
  @media only screen and (max-width: 711px) {
    max-width: calc(100% + 1rem);
    width: calc(100% + 1rem);
    padding-right: 2rem;
    margin-left: -2rem;
    padding-left: 15px;
    padding-right: 15px;
  }
`

const KeyWrapper = styled.div`
  max-width: 730px;

  width: 100%;
  margin-left: auto;
  margin-right: auto;
  flex: 0 0 10%;
`

const VideoSource = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 12px;
  color: var(--gray-3);
  a {
    color: var(--blue-main);
    text-decoration: none;
  }
`

const TimeTitle = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: left;
  font-size: 22px;
  color: var(--text-color);
  font-weight: 700;
  padding-bottom: 1em;
  padding-top: 0.25em;
  font-family: var(--font-sans-serif);

  width: 100%;
  text-align: left;
  flex: 0 0 10%;
  @media only screen and (max-width: 711px) {
    font-size: 20px;
  }
`
const Source = styled.div`
  margin-top: 15px;
  font-family: var(--font-sans-serif);
  font-size: 12px;
  color: var(--gray-3);
  margin-bottom: 60px;
  @media only screen and (max-width: 711px) {
    margin-bottom: 30px;
    padding-left: 2rem;
  }
  a {
    color: var(--text-color);
  }
`
const MapWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;

  @media only screen and (max-width: 711px) {
    /* width: 118%;
    margin-left: -9%; */
    max-width: 100vw;
    overflow: hidden;
    margin-left: -2rem;
    max-width: calc(100% + 4rem);
    width: calc(100% + 4rem);
  }
`
const AppContainer = styled(TamediaStyles)<{
  tenant?: string
}>`
  width: 100%;

  margin: 0;
  margin-top: 60px;
  margin-bottom: 60px;
  padding: 0;

  font-family: var(--font-sans-serif);
  color: var(--brandblue-main);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--site-background);
  @media (prefers-reduced-motion: no-preference) {
    .App-logo {
      animation: App-logo-spin infinite 20s linear;
    }
  }

  @keyframes App-logo-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`
export default MainComponent
